import {InputAdornment} from '@mui/material';
import TextField from '@jobseeker/lotus/elements/Input';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {Image} from '@jobseeker/lotus/components/Image';
import {Search} from '@jobseeker/lotus/assets/icons';
import {BaseSyntheticEvent} from 'react';

export type PersonalizeSearchType = {
  searchValue: string;
  width?: string;
  onFilterChange?: (event: BaseSyntheticEvent) => void;
};
const PersonalizeSearch = ({
  searchValue,
  width,
  onFilterChange,
}: PersonalizeSearchType) => {
  return (
    <TextField
      placeholder="Search Tags"
      variant={VersionVariants.VERSION_ONE}
      aria-autocomplete="list"
      aria-expanded="true"
      autoComplete="off"
      spellCheck="false"
      aria-invalid="false"
      name="query"
      value={searchValue}
      onChange={onFilterChange}
      // helperText={'Few special character and spaces are not allowed'}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Image
              src={Search}
              alt={'Search'}
              width={18}
              height={18}
              style={{
                filter: 'brightness(3)',
              }}
              objectFit="cover"
            />
          </InputAdornment>
        ),
      }}
      sx={{
        zIndex: 3,
        fontSize: 12,
        width: width,
        '.MuiInputBase-root': {
          fontSize: 12,
          width: width ?? '240px',
          height: '32px',
          borderRadius: 4,
        },
        '& .MuiOutlinedInput-root': {
          '&.Mui-focused fieldset': {
            borderColor: 'text.primary',
            borderWidth: '1px',
          },
        },
        mb: {xxs: 0.5, md: 0},
      }}
    />
  );
};

export default PersonalizeSearch;
